import React from "react";

export default function CricketMatch2020({ resultData }) {
  if (!resultData) return null;

  const {
    casinoIndividualResultDTO,
    casinoCardResultMaps,
    casinoIndividualResultMaps,
  } = resultData || {};

  const roundId = casinoIndividualResultDTO?.marketId || "N/A";
  const matchTime = casinoIndividualResultDTO?.createdAt || "N/A";

  const cardCode = casinoCardResultMaps?.[0]?.result?.[0] || "JH"; // fallback card
  const runValue = casinoIndividualResultMaps?.[0]?.result?.[0] || "-";

  const cardImgUrl = `https://g1ver.sprintstaticdata.com/v53/static/front/img/cards/${cardCode}.jpg`;

  return (
    <div className="modal-dialog modal-xl">
      <div className="modal-content">
        <div className="modal-body">
          <div className="casino-result-modal">
            <div className="casino-result-round-id">
              <span>
                <b>Round Id: </b> {roundId}
              </span>
              <span>
                <b>Match Time: </b> {matchTime}
              </span>
            </div>

            <div className="row mt-2">
              <div className="col-md-12 text-center">
                <div className="casino-result-cards">
                  <img src={cardImgUrl} alt={cardCode} />
                </div>
              </div>
            </div>

            <div className="row mt-2 justify-content-center">
              <div className="col-md-6">
                <div className="casino-result-desc">
                  <div className="casino-result-desc-item">
                    <div>Run</div>
                    <div>{runValue}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
